import { Priority } from "../../../../../../../../../utils/enums/priority";
import { ACTIONS } from "../../../enums/actions";
import { Action, State } from "../../../types"


const normalizeString = (str: string) => str.trim().toLowerCase();

const initialState: State = {
  expand: true,
  openModal: { open: false },
  openModalDelete: { open: false, confirm: undefined },
  openModalChangePriority: { open: false, confirm: undefined },
  openModalProvider: { open: false },
  editId: 0,
  checked: false,
  idChildren: [],
  provider: [],
  providerCopy: [],
  searchValue: undefined,
  priority: undefined,
  searchSubServiceValue: undefined,
  providerValue: undefined
};

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ACTIONS.TOGGLE_EXPAND:
      return { ...state, expand: !state.expand };
    case ACTIONS.CHECKED:
      return { ...state, checked: !state.checked };
    case ACTIONS.CHECKED_BY_PARENT:
      return { ...state, checked: action.payload.check };
    case ACTIONS.OPEN_MODAL:
      return {
        ...state,
        openModal: {
          open: true,
          title: action.payload.title,
          cancel: action.payload.cancel,
        },
      };
    case ACTIONS.CLOSE_MODAL:
      return {
        ...state,
        openModal: null,
      };
    case ACTIONS.SET_EDIT_ID:
      return {
        ...state,
        editId: action.payload,
      };
    case ACTIONS.SET_PRIORITY:
      return {
        ...state,
        priority: {
          id: action.payload.id,
          name: action.payload.name
        }
      };
    case ACTIONS.OPEN_MODAL_DELETE:
      return {
        ...state,
        openModalDelete: {
          open: true,
          title: action.payload.title,
          description: action.payload.description,
          confirm: action.payload.confirm,
          cancel: action.payload.cancel,
        },
      };
    case ACTIONS.CLOSE_MODAL_DELETE:
      return {
        ...state,
        openModalDelete: null,
      };
    case ACTIONS.OPEN_MODAL_PROVIDER:
      return {
        ...state,
        openModalProvider: {
          open: true,
          title: action.payload.title,
          description: action.payload.description,
          cancel: action.payload.cancel,
        },
        searchValue: undefined,
        provider: state.providerCopy
      };
    case ACTIONS.CLOSE_MODAL_PROVIDER:
      return {
        ...state,
        openModalProvider: null,
      };
    case ACTIONS.RESET_EDIT_ID:
      return {
        ...state,
        editId: 0,
      };
    case ACTIONS.RESET_PRIORITY:
      return {
        ...state,
        priority: undefined
      };
    case ACTIONS.ADD_CHILDREN:
      return {
        ...state,
        idChildren: [
          ...(state.idChildren || []),
          action.payload.id
        ]
      };
    case ACTIONS.DELETE_CHILDREN:
      return {
        ...state,
        idChildren: (state.idChildren || []).filter(id => id !== action.payload.id)
      };
    case ACTIONS.HANDLE_PROVIDERS_CHECK:
      return {
        ...state,
        providerValue: (action.payload.id && action.payload.name) ? {
          id: action.payload.id,
          name:action.payload.name
        } : undefined
      };
    case ACTIONS.HANDLE_PROVIDERS_NOT_CHECK:
      return {
        ...state,
        providerValue: undefined
      };
    case ACTIONS.ADD_ALL_CHILDREN:
      return {
        ...state,
        idChildren: [
          ...(state.idChildren || []),
          ...action.payload.childs
            .filter(child => (child.priority?.id === Priority.HIGH || child.priority?.id === Priority.URGENT)  && !(state.idChildren || []).includes(child.id)) // Filtra los hijos de prioridad alta y excluye los que ya están
            .map(child => child.id) // Extrae solo los IDs
        ]
      };
    case ACTIONS.DELETE_ALL_CHILDREN:
      return {
        ...state,
        idChildren: []
      };
    case ACTIONS.FILTER_PROVIDERS_BY_VALUE:
      return {
        ...state,
        provider: state.providerCopy?.filter(provider => normalizeString(provider.label).includes(normalizeString(state.searchValue || "")))
      };
    case ACTIONS.INITIALIZE_ARRAYS:
      return {
        ...state,
        provider: action.payload,
        providerCopy: action.payload
      };
    case ACTIONS.SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.payload
      };
    case ACTIONS.SEARCH_SUBSERVICE_VALUE:
      return {
        ...state,
        searchSubServiceValue: action.payload
      };
    default:
      return state;
  }
};



export { reducer, initialState, normalizeString }